var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"terms-of-use"},[_c('v-col',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.privacyPolicy)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }